module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools-screen3-fe8c7195245981cf07bb6e3020cb41e9.png";